var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.Calciatore
    ? _c(
        "div",
        {
          staticClass: "calciatore-battuto",
          class: [_vm.sizeClass, { clickable: _vm.isClickable }],
          style: {
            backgroundImage:
              "url(" +
              (_vm.Calciatore.ID_Club
                ? _vm.Config.PUBLIC_DIR +
                  "/clubs/maglie/400x400/ID_Anno_" +
                  _vm.Config.ID_ANNO_MAGLIE +
                  "/img_scheda_club_" +
                  _vm.Calciatore.ID_Club +
                  ".png"
                : "") +
              ")",
          },
          on: { click: _vm.handleClick },
        },
        [
          _vm.sizeClass == "extra-small"
            ? _c(
                "div",
                { staticClass: "extra-small-content" },
                [
                  _vm.classic
                    ? _c(
                        "span",
                        {
                          class: ["Ruolo", "Ruolo_" + _vm.Calciatore.ID_Ruolo],
                        },
                        [_vm._v(_vm._s(_vm.ruolo(_vm.Calciatore.ID_Ruolo)))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "extra-small-details" }, [
                    _c(
                      "span",
                      {
                        staticClass: "nomeCalciatore",
                        attrs: { title: _vm.Calciatore.calciatore },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.Calciatore.calciatore) +
                            "\n      "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.Calciatore.nomeClub
                      ? _c("span", { staticClass: "nomeClub ellipsis" }, [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.Calciatore.nomeClub) +
                              "\n      "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _vm.showQuotazione
                    ? _c("quotazione", {
                        attrs: {
                          quotazione: _vm.Calciatore.quotazione,
                          small: "",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.Calciatore.ms
                    ? _c("main-status", {
                        attrs: { ms: _vm.Calciatore.ms, small: "" },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", { staticClass: "extra-small-shirt-spacer" }),
                ],
                1
              )
            : _vm.sizeClass != "small"
            ? _c(
                "div",
                [
                  _c("div", { staticClass: "nomeCalciatore" }, [
                    _vm.classic
                      ? _c(
                          "span",
                          {
                            class: [
                              "Ruolo",
                              "Ruolo_" + _vm.Calciatore.ID_Ruolo,
                            ],
                          },
                          [_vm._v(_vm._s(_vm.ruolo(_vm.Calciatore.ID_Ruolo)))]
                        )
                      : _vm._e(),
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.Calciatore.calciatore) +
                        "\n      "
                    ),
                    _vm.mantra
                      ? _c(
                          "span",
                          _vm._l(
                            _vm.Calciatore.mantra_ids,
                            function (mantra_id) {
                              return _c(
                                "span",
                                {
                                  key: mantra_id,
                                  class: [
                                    "ml-1",
                                    "ruolo-mantra",
                                    "ruolo-mantra" + mantra_id,
                                  ],
                                },
                                [_vm._v(_vm._s(_vm.ruoloMantra(mantra_id)))]
                              )
                            }
                          ),
                          0
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "photo" }, [
                    _c("div", { staticClass: "imgCalciatore without-ms" }, [
                      _c(
                        "div",
                        { staticClass: "imgContainer imgContainer-ruolo_" },
                        [
                          _vm.Config.AVATAR_OR_FLAG == "avatar"
                            ? _c("div", {
                                key: _vm.Calciatore.nid,
                                staticClass: "img",
                                style: {
                                  backgroundImage:
                                    "url(" +
                                    (_vm.Calciatore.imgCalciatore
                                      ? _vm.Calciatore.imgCalciatore
                                      : _vm.Config.PUBLIC_DIR +
                                        "/schede_calciatori/avatar/default/avatar_club_" +
                                        _vm.Calciatore.ID_Club +
                                        ".png") +
                                    ")",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.Config.AVATAR_OR_FLAG == "flag"
                            ? _c("div", {
                                key: _vm.Calciatore.nid,
                                staticClass: "img flag",
                                style: {
                                  backgroundImage:
                                    "url(" +
                                    (_vm.Config.PUBLIC_DIR +
                                      "/clubs/flags/flag_" +
                                      _vm.Calciatore.ID_Club +
                                      ".png") +
                                    ")",
                                },
                              })
                            : _vm._e(),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "nomeClub ellipsis" }, [
                    _vm._v(_vm._s(_vm.Calciatore.nomeClub)),
                  ]),
                  _vm._v(" "),
                  _vm.showQuotazione
                    ? _c("quotazione", {
                        attrs: { quotazione: _vm.Calciatore.quotazione },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "mainStatusPlaceholder" },
                    [_c("main-status", { attrs: { ms: _vm.Calciatore.ms } })],
                    1
                  ),
                ],
                1
              )
            : _c("div", { staticClass: "d-flex" }, [
                _c("div", { staticClass: "photo" }, [
                  _c(
                    "span",
                    { class: ["Ruolo", "Ruolo_" + _vm.Calciatore.ID_Ruolo] },
                    [_vm._v(_vm._s(_vm.ruolo(_vm.Calciatore.ID_Ruolo)))]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "imgCalciatore without-ms" }, [
                    _c(
                      "div",
                      { staticClass: "imgContainer imgContainer-ruolo_" },
                      [
                        _vm.Config.AVATAR_OR_FLAG == "avatar"
                          ? _c("div", {
                              key: _vm.Calciatore.nid,
                              staticClass: "img",
                              style: {
                                backgroundImage:
                                  "url(" +
                                  (_vm.Calciatore.imgCalciatore
                                    ? _vm.Calciatore.imgCalciatore
                                    : _vm.Config.PUBLIC_DIR +
                                      "/schede_calciatori/avatar/default/avatar_club_" +
                                      _vm.Calciatore.ID_Club +
                                      ".png") +
                                  ")",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.Config.AVATAR_OR_FLAG == "flag"
                          ? _c("div", {
                              key: _vm.Calciatore.nid,
                              staticClass: "img flag",
                              style: {
                                backgroundImage:
                                  "url(" +
                                  (_vm.Config.PUBLIC_DIR +
                                    "/clubs/flags/flag_" +
                                    _vm.Calciatore.ID_Club +
                                    ".png") +
                                  ")",
                              },
                            })
                          : _vm._e(),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex flex-column align-start justify-space-around",
                  },
                  [
                    _c("div", { staticClass: "nomeCalciatore" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.Calciatore.calciatore) +
                          "\n      "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "nomeClub ellipsis" }, [
                      _vm._v(_vm._s(_vm.Calciatore.nomeClub)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex align-center" },
                      [
                        _vm.Calciatore.ms
                          ? _c("main-status", {
                              attrs: { ms: _vm.Calciatore.ms, small: "" },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showQuotazione
                          ? _c("quotazione", {
                              staticClass: "ml-1",
                              attrs: {
                                quotazione: _vm.Calciatore.quotazione,
                                small: "",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }